import React, { useEffect, useRef, useState } from 'react';
import { useNotification } from './NotificationContext';
import './NotificationPopup.css';
const CLOSE_ANIMATION_MS = 300;

const NotificationPopup = ({ notification, onClose, onAdjustPrice, onGrabOrder, index = 0 }) => {
  const { grabOrderAutoDismissMs } = useNotification();
  const { id, productName, winningVendor, winningPrice, isVisible, from, lowestPrice, SKU, shownAt, type } =
    notification;
  const [isClosing, setIsClosing] = useState(false);
  const onCloseRef = useRef(onClose);
  const notificationRef = useRef(notification);

  onCloseRef.current = onClose;
  notificationRef.current = notification;

  const dismissNotification = (markAsRead = false) => {
    if (isClosing) return;
    setIsClosing(true);
    setTimeout(() => {
      onCloseRef.current(notificationRef.current, markAsRead);
    }, CLOSE_ANIMATION_MS);
  };

  useEffect(() => {
    if (!isVisible) return;

    const dismissMs = grabOrderAutoDismissMs || 10000;
    const startedAt = shownAt || Date.now();
    const remaining = Math.max(0, dismissMs - (Date.now() - startedAt));

    const timer = setTimeout(() => {
      dismissNotification(type === 'order_lost');
    }, remaining);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible, id, shownAt, type, grabOrderAutoDismissMs]);

  if (!isVisible) return null;

  const bottomPosition = 25 + index * 130;

  const renderCombination = () => {
    if (from === 'notification') {
      const attrValues = JSON.parse(notification.attributeValue || '[]');
      const attrs = JSON.parse(notification.attributes || '[]');
      const pairs = attrs.map((item, idx) => `${item} - ${attrValues[idx]}`);
      if (pairs?.length === 0) return '';
      return `(${pairs.join(', ')})`;
    }
    if (notification?.foundCombination) {
      const comb = notification.foundCombination;
      const attributes = notification.attributes;
      const pairs = attributes?.value?.map((item, idx) => `${item} - ${comb?.value?.[idx]}`);
      if (pairs?.length === 0) return '';
      return `(${pairs.join(', ')})`;
    }
    return '';
  };

  const getTitle = (notifType) => {
    switch (notifType) {
      case 'grab_order':
        return 'Grab Order';
      case 'order_lost':
        return 'Order Lost';
      default:
        return 'Notification';
    }
  };

  if (getTitle(type) === 'Grab Order') {
    return (
      <div className={`notification-list-item ${isClosing ? 'notification-item-closing' : ''}`} key={id}>
        <div className="notification-content">
          <div className="notification-body" onClick={() => onGrabOrder(id)}>
            <div className="notification-message">
              <p>
                <span className="product-name-notification">
                  {productName.length > 80 ? `${productName.slice(0, 80)}...` : productName}{' '}
                  {notification && renderCombination()}
                </span>
              </p>
              <p className="sku-1 mt-1">{SKU}</p>
              <div className="d-flex justify-content-between mt-1">
                <p className="winning-price-11">
                  <span className="winning-price">
                    ₹{notification?.expTransferPriceFrom} - ₹{notification?.expTransferPriceTo}
                  </span>
                </p>
                <button type="button" className="adjust-price-btn">
                  Grab order →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (getTitle(type) === 'Order Lost') {
    return (
      <div
        className={`notification-popup ${isClosing ? 'notification-popup-closing' : ''}`}
        key={id}
        style={{ bottom: `${bottomPosition}px` }}
      >
        <div className="notification-content">
          <div className="notification-icon">
            <i className="bi bi-lightning-charge-fill"></i>
          </div>
          <div className="notification-body" onClick={() => onAdjustPrice(id)}>
            <div className="notification-header">
              <h6 className="notification-title">{getTitle(type)}</h6>
              <button
                type="button"
                className="notification-close"
                onClick={(e) => {
                  e.stopPropagation();
                  dismissNotification(true);
                }}
              >
                <i className="bi bi-x"></i>
              </button>
            </div>
            <div className="notification-message">
              <p>
                <span className="product-name-notification">
                  {productName.length > 90 ? productName.slice(0, 90) : productName}{' '}
                  {notification && renderCombination()}
                </span>{' '}
                was assigned to some other vendor
              </p>
              <p className="winnning-price-11">
                Winning Price: <span className="winning-price">₹{lowestPrice}</span>
              </p>
              <button type="button" className="adjust-price-btn">
                Click to adjust your price →
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default NotificationPopup;
